module.exports = __webpack_public_path__ + "img/english-premier-league-36.5373f953.png";